/**
 * File events.js.
 *
 * Handles events list blocks.
 */
(function ($) {
    'use strict';
    
    $(document).ready(function () {
        // Event filter search base
        $(document).on('click', '.event__filters .event__search-submit', function () {
            let filterItem = $(this).parents('.event__list-wrap');
            let eventsPerPage = $(this).parents('.event__list-wrap').attr('data-events-per-page');
            let selectedEvents = $(this).parents('.event__list-wrap').attr('data-selected-events');
            let allCategories = $(this).parents('.event__list-wrap').attr('data-categories');
            let buttonText = $(this).parents('.event__list-wrap').attr('data-button-text');
            let search = $('.event__filters .event__search-input').val();
            let zone = $('.event__category-active a').attr('data-zone-id');
            eventsListAjax( allCategories, selectedEvents, false, filterItem, 'all', 1, eventsPerPage, buttonText, search );
        });

        // Event filter search base by clicking enter button
        $(document).on('keypress', '.event__filters .event__search-input', function (event) {
            if ( event.keyCode == 13 ) {
                let filterItem = $(this).parents('.event__list-wrap');
                let eventsPerPage = $(this).parents('.event__list-wrap').attr('data-events-per-page');
                let selectedEvents = $(this).parents('.event__list-wrap').attr('data-selected-events');
                let allCategories = $(this).parents('.event__list-wrap').attr('data-categories');
                let buttonText = $(this).parents('.event__list-wrap').attr('data-button-text');
                let search = $('.event__filters .event__search-input').val();
                let zone = $('.event__category-active a').attr('data-zone-id');
                eventsListAjax( allCategories, selectedEvents, false, filterItem, zone, 1, eventsPerPage, buttonText, search );
            }
        });

        // Show search close icon
        $(document).on('keyup', '.event__filters .event__search-input', function () {
            if ( '' === $(this).val() ) {
                $('.event__filters .event__search-close').hide();
            } else {
                $('.event__filters .event__search-close').show();
            }
        });

        // Show search close icon
        $(document).on('click', '.event__filters .event__search-close', function () {
            let filterItem = $(this).parents('.event__list-wrap');
            let eventsPerPage = $(this).parents('.event__list-wrap').attr('data-events-per-page');
            let selectedEvents = $(this).parents('.event__list-wrap').attr('data-selected-events');
            let allCategories = $(this).parents('.event__list-wrap').attr('data-categories');
            let buttonText = $(this).parents('.event__list-wrap').attr('data-button-text');
            $('.event__filters .event__search-input').val('');
            $('.event__filters .event__search-close').hide();
            let zone = $('.event__category-active a').attr('data-zone-id');
            eventsListAjax( allCategories, selectedEvents, false, filterItem, zone, 1, eventsPerPage, buttonText, '' );
        });
        
        // Event filter zone wise
        $(document).on('click', '.event__categories-list a', function () {
            $('.event__categories-list li').removeClass('event__category-active');
            $(this).parent('li').addClass('event__category-active');

            let zone = $(this).attr('data-zone-id');
            let filterItem = $(this).parents('.event__list-wrap');
            let eventsPerPage = $(this).parents('.event__list-wrap').attr('data-events-per-page');
            let selectedEvents = $(this).parents('.event__list-wrap').attr('data-selected-events');
            let allCategories = $(this).parents('.event__list-wrap').attr('data-categories');
            let buttonText = $(this).parents('.event__list-wrap').attr('data-button-text');
            let search = $('.event__filters .event__search-input').val();
            eventsListAjax( allCategories, selectedEvents, false, filterItem, zone, 1, eventsPerPage, buttonText, search );
        });

        // Load more events
        $(document).on('click', '.event__load-more .btn-main', function () {
            let paged = $(this).attr('data-page') ? parseInt($(this).attr('data-page')) + 1 : 1;
            let filterItem = $(this).parents('.event__list-wrap');
            let eventsPerPage = $(this).parents('.event__list-wrap').attr('data-events-per-page');
            let buttonText = $(this).parents('.event__list-wrap').attr('data-button-text');
            let selectedEvents = $(this).parents('.event__list-wrap').attr('data-selected-events');
            let allCategories = $(this).parents('.event__list-wrap').attr('data-categories');
            let search = $('.event__filters .event__search-input').val();
            let zone = $('.event__category-active a').attr('data-zone-id');
            eventsListAjax( allCategories, selectedEvents, true, filterItem, zone, paged, eventsPerPage, buttonText, search );
        });
    });

    // Ajax For Press List Block
    function eventsListAjax(allCategories, selectedEvents, loadMore, filterItem, zone, paged, eventsPerPage, buttonText, search = '', scrollInView = false) {
        if ( ! loadMore ) {
            filterItem.find('.event__row').html('');
            $( '.event__row' ).html( '<div class="loader-icon"></div>' );
            filterItem.find('.event__row').addClass('efi-loader');
        } else {
            filterItem.find('.event__load-more').addClass('event__loading');
        }
        jQuery.ajax({
            type: 'POST',
            dataType: "json",
            data: {
                action: 'efi_events_list',
                event_per_page: eventsPerPage,
                zone: zone,
                ajax_nonce: siteConfig.ajax_nonce,
                paged: paged,
                selected_events: selectedEvents,
                all_categories: allCategories,
                search: search,
            },
            url: siteConfig.ajaxUrl,
            success: function (eventData) {
                let eventObj = eventData.data.result;
                
                if ( ! loadMore ) {
                    filterItem.find('.event__row').html('');
                }

                if ( eventObj && 0 < eventObj.length ) {
                    
                    $.each( eventObj, function ( key, item ) {
                        let eventItem = document.createElement('div');
                        eventItem.setAttribute('class', 'event__item');

                        let imgSection = document.createElement('div');
                        imgSection.setAttribute('class', 'event__img');

                        let eventImg = document.createElement('img');
                        eventImg.setAttribute('src', item.event_img);
                        eventImg.setAttribute('alt', item.title);

                        if ( item.website_url ) {
                            let websiteUrl = document.createElement('a');
                            websiteUrl.setAttribute('href', item.website_url);
                            websiteUrl.setAttribute('target', '_blank');
                            websiteUrl.appendChild(eventImg);
                            imgSection.appendChild(websiteUrl);
                        } else {
                            imgSection.appendChild(eventImg);   
                        }

                        let contentSection = document.createElement('div');
                        contentSection.setAttribute('class', 'event__content');

                        let eventTitle = document.createElement('h2');

                        if ( item.website_url ) {
                            let websiteUrl = document.createElement('a');
                            websiteUrl.setAttribute('href', item.website_url);
                            websiteUrl.setAttribute('target', '_blank');
                            websiteUrl.innerText = item.title;
                            eventTitle.appendChild(websiteUrl);
                        } else {
                            eventTitle.innerText = item.title;   
                        }

                        contentSection.appendChild(eventTitle);

                        if ( item.location ) {
                            let eventLocation = document.createElement('p');
                            eventLocation.setAttribute('class', 'event__location');
                            eventLocation.innerText = item.location;
                            contentSection.appendChild(eventLocation);
                        }

                        if ( item.city ) {
                            let eventCity = document.createElement('p');
                            eventCity.setAttribute('class', 'event__city');
                            eventCity.innerText = item.city;
                            contentSection.appendChild(eventCity);
                        }

                        if ( item.event_date ) {
                            let eventDate = document.createElement('p');
                            eventDate.setAttribute('class', 'event__date');
                            eventDate.innerText = item.event_date;

                            let calendarIcon = document.createElement('span');
                            calendarIcon.setAttribute('class', 'event__calendar-icon');
                            eventDate.prepend(calendarIcon);
                            contentSection.appendChild(eventDate);
                        }

                        eventItem.appendChild(imgSection);
                        eventItem.appendChild(contentSection);

                        if ( item.website_url && buttonText ) {
                            let eventButton = document.createElement('div');
                            eventButton.setAttribute('class', 'event__button');
                            
                            let buttonUrl = document.createElement('a');
                            buttonUrl.setAttribute('class', 'btn-main');
                            buttonUrl.setAttribute('href', item.website_url);
                            buttonUrl.setAttribute('target', '_blank');
                            buttonUrl.innerText = buttonText;
                            eventButton.appendChild(buttonUrl);

                            eventItem.appendChild(eventButton);
                        }

                        filterItem.find('.event__row').append(eventItem);
                    })
                } else {
                    let eventNotFound = document.createElement('p');
                    eventNotFound.setAttribute('class', 'event__not-found');
                    eventNotFound.innerText = eventData.data.no_data_msg;
                    filterItem.find('.event__row').html( eventNotFound );
                }

                let maxPages = eventData.data.max_pages;
                let loadMoreObj = filterItem.find('.event__load-more .btn-main');

                filterItem.attr('data-max-page', maxPages);
                loadMoreObj.attr('data-page', paged);
                if (maxPages > paged) {
                    loadMoreObj.show();
                } else {
                    loadMoreObj.hide();
                }
                
                if (scrollInView) {
                    filterItem[0].scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
                }
                filterItem.find('.event__load-more').removeClass('event__loading');
            }
        });
    }
})(jQuery);